import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "BYBETJENTSEKSJONER";

export function getBybetjentSeksjoner() {
  return axiosUtils.GetAll(api.GET_BYBETJENTSEKSJONER_URL, actionType);
}
